// import * as Sentry from '@sentry/browser';
import { FormId } from '_constants/forms';
import React from 'react';

interface Props {
  children: React.ReactNode;
  formId?: FormId;
}

const Form: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
  return <>{children}</>;
};

export default Form;
